export const YANKED_VERSION_VALUE = "BAD";
export const DEFAULT_SPACE_NAME = "root";
